<template>
  <div style="margin-top: 20px;" class="ma-1">
    <v-container class="ma-1" style="max-width: 2000px;">
      <!-- <v-layout row></v-layout> -->
      <v-layout row>
        <v-btn text large v-if="!drawer" @click="drawer = true">
          <!-- MENU <v-icon>mdi-dots-vertical</v-icon> -->
          MENU <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          large
          v-if="!rightDrawer"
          @click.stop="rightDrawer = !rightDrawer"
          ><v-icon>mdi-chevron-left</v-icon>INFO
        </v-btn>
      </v-layout>
      <v-navigation-drawer
        v-model="drawer"
        style="border-right: 1px solid; border-color: #a07800"
        app
        clipped
      >
        <v-card class="ml-auto mr-auto" flat>
          <v-layout>
            <v-spacer></v-spacer>
            <v-btn right icon @click.stop="drawer = !drawer"
              ><v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-layout>
          <v-card-text class="title text-center">MATTER MENU</v-card-text>
          <v-list class="pl-8" shaped>
            <!-- <v-list-item class="ma-auto">
            <v-spacer></v-spacer>
            <v-btn right icon @click.stop="drawer = !drawer"
              ><v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-list-item> -->

            <v-list-item class="ma-auto">
              <v-btn
                class="ma-auto"
                text
                large
                @click="toggleShowPlaintiffs"
                width="100%"
                >PLAINTIFFS
                <v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showPlaintiffs"
                  v-if="showPlaintiffs"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>

            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" large text @click="toggleShowDefendants"
                >DEFENDANTS
                <v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showDefendants"
                  v-if="showDefendants"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card> -->
            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" large text @click="toggleShowNotes"
                >NOTES<v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showNotes"
                  v-if="showNotes"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card> -->
            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" large text @click="toggleShowActivities"
                >ACTIVITIES<v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showActivities"
                  v-if="showActivities"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card> -->
            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" large text @click="toggleShowCaseInfo"
                >CASE INFO<v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="showCaseInfo = !showCaseInfo"
                  v-if="showCaseInfo"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card> -->
            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" text large @click="toggleShowAttorneys"
                >ATTORNEYS<v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showAttorneys"
                  v-if="showAttorneys"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card> -->

            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" text large @click="togglShowCreator"
                >CASE ACCESS<v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showCreator"
                  v-if="showCreator"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card> -->
            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" text large @click="toggleShowFirms"
                >FIRMS<v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showFirms"
                  v-if="showFirms"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card> -->

            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" text large @click="toggleShowInitialDocs"
                >INITIAL DOCS<v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showInitialDocs"
                  v-if="showInitialDocs"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card> -->
            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" text large @click="toggleShowServiceList"
                >SERVICE LIST<v-btn
                  rounded
                  small
                  text
                  class="red--text"
                  @click="!showServiceList"
                  v-if="showServiceList"
                  >HIDE</v-btn
                >
              </v-btn>
            </v-list-item>
            <!-- </v-card>
          <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn class="ma-auto" text large @click="canvasDialog = true"
                >LETTERHEAD
              </v-btn>
              <v-dialog v-model="canvasDialog" width="75%" height="75%">
                <v-file-input
                  class="ma-1"
                  outlined
                  chips
                  label="Upload Letterhead Image"
                  ref="fileInput"
                  @change="onFilePicked"
                  dense
                  color="#a07800"
                ></v-file-input>

                <canvas width="700px" height="300px" id="temp-canvas"></canvas>
                <v-btn @click="canvasDialog = false">EXIT</v-btn>
                <v-btn :disabled="!letterhead" @click="saveLetterhead"
                  >save</v-btn
                >
              </v-dialog>
            </v-list-item>
            <!-- </v-card>
          <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item>
              <v-list-item-title>
                <template>
                  <div>
                    <app-video-conf-dialog
                      :matter="matter"
                      :user="user"
                    ></app-video-conf-dialog>
                  </div>
                </template>
              </v-list-item-title>
            </v-list-item>
            <!-- </v-card> -->
            <!-- <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item>
              <v-list-item-title>
                <template>
                  <div>
                    <app-edit-matter-dialog
                      :matter="matter"
                    ></app-edit-matter-dialog>
                  </div>
                </template>
              </v-list-item-title>
            </v-list-item>
            <!-- </v-card>
          <v-card
            outlined
            shaped
            tile
            style="background-color: black; border: 1px solid #a07800"
            class="ma-1"
          > -->
            <v-list-item class="ma-auto">
              <v-btn
                class="ma-auto"
                text
                large
                @click="onDeleteMatter"
                v-if="
                  user !== null && user !== undefined && user.role === 'admin'
                "
                :disabled="user.email !== matter.creatorID"
                >DELETE MATTER</v-btn
              >
              <!-- </v-list-item-title> -->
            </v-list-item>
            <!-- </v-card> -->
          </v-list>
        </v-card>
      </v-navigation-drawer>
      <v-navigation-drawer
        app
        right
        clipped
        v-model="rightDrawer"
        width="300px"
        style="border-left: 1px solid; border-color: #a07800"
      >
        <v-card class="ml-auto mr-auto" flat>
          <v-btn right icon @click.stop="rightDrawer = !rightDrawer"
            ><v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-card-text class="title text-center">CASE INFO</v-card-text>

          <v-simple-table class="text-center ml-3 body-2" dense>
            <tbody>
              <tr>
                <td class="caption">DATE OF LOSS</td>
                <td class="caption">{{ matter ? matter.dateOfLoss : "**" }}</td>
              </tr>
              <tr>
                <td class="caption">DATE FILED</td>
                <td class="caption" v-if="matter && !matter.dateOfComplaint">
                  <v-btn
                    rounded
                    outlined
                    color="green"
                    small
                    @click="editDateOfComplaint"
                    >INPUT DATE</v-btn
                  >
                </td>
                <td class="caption" v-else>
                  {{ matter ? matter.dateOfComplaint : "**" }}
                </td>
              </tr>
              <tr>
                <td class="caption">COMPLAINT DEADLINE</td>
                <td class="caption">
                  {{ matter ? matter.complaintDeadline : "**" }}
                </td>
              </tr>

              <tr>
                <td class="caption">STATUS</td>
                <td class="caption">
                  {{ matter ? matter.status.toUpperCase() : "**" }}
                </td>
              </tr>
              <tr>
                <td class="caption">DATE CREATED</td>
                <td class="caption">
                  {{ matter ? matter.dateCreated : "**" }}
                </td>
              </tr>
              <tr>
                <td class="caption">ID</td>
                <td class="caption">{{ matter ? matter.matterSlug : "**" }}</td>
              </tr>

              <tr>
                <td class="caption">CREATOR</td>
                <td class="caption">{{ matter ? matter.creatorID : "**" }}</td>
              </tr>
              <tr></tr></tbody
          ></v-simple-table>
        </v-card>
      </v-navigation-drawer>
      <!-- <v-main> -->
      <v-container>
        <v-layout text-center wrap>
          <v-flex xs12>
            <v-flex class="ma-auto">
              <v-card
                class="ma-1"
                flat
                style="background-color: transparent; border-radius: 26px; "
              >
                <v-card class="ma-auto">
                  <v-layout class="ma-auto" row id="">
                    <!-- matter menue -->

                    <v-spacer></v-spacer>

                    <div class="display-1 ">
                      {{ matter ? matter.caseName : "**" }}
                      <span
                        v-if="
                          matter.specialTitle !== null &&
                            matter.specialTitle !== undefined
                        "
                      >
                        >--
                        {{ matter.specialTitle || "" }}</span
                      >
                      <!-- {{ matter ? `${matter.specialTitle}` : "**" }}</span
                      > -->
                    </div>
                    <v-spacer></v-spacer>
                  </v-layout>
                </v-card>

                <hr size="1px" style="width: 90%;" class="ma-auto" />
                <!-- <v-container class="ma-auto s12"> -->
                <v-container class="ma-auto s12" style="min-width: 100%">
                  <v-layout text-center class="ma-1 row wrap">
                    <!-- ******************************************************* -->
                    <!-- ******************************************************* -->
                    <!-- ACTION VIEW CARD -->
                    <!-- ******************************************************* -->
                    <!-- ******************************************************* -->

                    <v-expand-x-transition>
                      <v-flex
                        xs12
                        sm12
                        md12
                        lg12
                        class="ma-2"
                        v-if="middleView"
                      >
                        <v-card class="ma-auto" falt outlined v-if="middleView">
                          <!-- =================PLAINTIFFS=================== -->
                          <v-expand-transition v-if="showPlaintiffs">
                            <div v-if="showPlaintiffs">
                              <!-- VIEW PLAINTIFFS  -->
                              <v-card
                                style="border: 2px solid black; width: auto;  overflow:auto;"
                                class="ma-2"
                                color="#E8E8E8"
                              >
                                <v-row class="mt-1">
                                  <v-col
                                    ><template>
                                      <div>
                                        <app-add-plaintiff-dialog
                                          :matter="matter"
                                          :user="user"
                                        ></app-add-plaintiff-dialog>
                                      </div> </template
                                  ></v-col>
                                  <v-col>
                                    <v-card-text class="title"
                                      >PLAINTIFFS
                                    </v-card-text></v-col
                                  >
                                  <v-col
                                    ><v-btn
                                      rounded
                                      text
                                      small
                                      color="red"
                                      @click="toggleShowPlaintiffs"
                                      v-if="showPlaintiffs"
                                      >HIDE</v-btn
                                    ></v-col
                                  >
                                </v-row>

                                <template>
                                  <div>
                                    <app-view-plaintiffs
                                      :matter="matter"
                                      :user="user"
                                    ></app-view-plaintiffs>
                                  </div>
                                </template>
                              </v-card>
                            </div>
                          </v-expand-transition>

                          <!-- =================DEFENDANTS=================== -->
                          <v-expand-transition>
                            <div v-if="showDefendants">
                              <!-- VIEW DEFENDANTS -->
                              <v-card-text class="display-1 black--text">
                                DEFENDANTS
                                <v-btn
                                  rounded
                                  outlined
                                  small
                                  color="red"
                                  @click="toggleShowDefendants"
                                  v-if="showDefendants"
                                  >HIDE</v-btn
                                >
                              </v-card-text>

                              <template>
                                <div>
                                  <app-view-defendants
                                    :matter="matter"
                                    :user="user"
                                  ></app-view-defendants>
                                </div>
                              </template>
                              <!-- ADD DEFENDANTS DIALOG -->
                              <template>
                                <div>
                                  <app-add-defendant-dialog
                                    :matter="matter"
                                    :user="user"
                                  ></app-add-defendant-dialog>
                                </div>
                              </template>
                              <!-- VIEW A DEFENDANT  -->
                              <template>
                                <div>
                                  <app-view-defendant></app-view-defendant>
                                </div>
                              </template>
                            </div>
                          </v-expand-transition>
                          <!-- =================ATTORNEYS=================== -->
                          <v-expand-transition>
                            <div v-if="showAttorneys">
                              <v-card
                                style="border: 2px solid black; width: auto;  overflow:auto;"
                                class="ma-2"
                                color="#E8E8E8"
                                max-height="50vh"
                              >
                                <v-row class="mt-1">
                                  <v-col
                                    ><template>
                                      <div>
                                        <app-add-attorney-dialog
                                          :matter="matter"
                                          :user="user"
                                        ></app-add-attorney-dialog>
                                      </div> </template
                                  ></v-col>
                                  <v-col>
                                    <v-card-text class="title"
                                      >ATTORNEYS
                                    </v-card-text></v-col
                                  >
                                  <v-col
                                    ><v-btn
                                      rounded
                                      text
                                      small
                                      color="red"
                                      @click="toggleShowAttorneys"
                                      v-if="showAttorneys"
                                      >HIDE</v-btn
                                    ></v-col
                                  >
                                </v-row>
                                <v-container v-if="matter">
                                  <div
                                    v-for="(attorney,
                                    index) in matter.attorneys"
                                    :key="index"
                                  >
                                    <v-card
                                      class="ma-auto"
                                      flat
                                      filled
                                      style="
                                    border-radius: 26px;
                                    border: 1px solid #18CAE6;
                                    max-width: 600px;
                                    "
                                    >
                                      <v-row>
                                        <v-flex>
                                          <v-card-text>
                                            {{ attorney.name.toUpperCase() }},
                                            SBN
                                            {{ attorney.barNumber }}
                                          </v-card-text>
                                        </v-flex>
                                        <v-spacer></v-spacer>
                                        <v-flex>
                                          <v-card-text>
                                            <v-btn
                                              small
                                              text
                                              rounded
                                              outlined
                                              color="red"
                                              @click="deleteAttorney(attorney)"
                                            >
                                              <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                          </v-card-text>
                                        </v-flex>
                                      </v-row>
                                    </v-card>
                                    <hr
                                      size="1px"
                                      color="#a07800"
                                      style="width: 75%"
                                      class="ml-auto mr-auto mt-1 mb-1"
                                    />
                                  </div>
                                </v-container>
                              </v-card>
                            </div>
                          </v-expand-transition>
                          <!-- =====================FIRMS====================== -->
                          <v-expand-transition>
                            <div v-if="showFirms">
                              <v-card
                                style="border: 2px solid black; width: auto;  overflow:auto;"
                                class="ma-2"
                                color="#E8E8E8"
                                max-height="50vh"
                              >
                                <v-row>
                                  <v-col>
                                    <template>
                                      <div>
                                        <app-add-firm-dialog
                                          :matter="matter"
                                          :user="user"
                                        ></app-add-firm-dialog>
                                      </div> </template
                                  ></v-col>
                                  <v-col>
                                    <v-card-text class="title">
                                      FIRMS
                                    </v-card-text></v-col
                                  >
                                  <v-col>
                                    <v-btn
                                      rounded
                                      small
                                      text
                                      color="red"
                                      @click="toggleShowFirms"
                                      v-if="showFirms"
                                      >HIDE</v-btn
                                    ></v-col
                                  >
                                </v-row>

                                <div
                                  v-for="(firm, index) in matter.firms"
                                  :key="index"
                                >
                                  <v-card>
                                    <div>
                                      {{ firm.firmName.toUpperCase() }}
                                    </div>
                                    <div>
                                      {{ firm.firmAddressLine.toUpperCase() }}
                                    </div>
                                    <div>
                                      {{ firm.firmCityStateZip.toUpperCase() }}
                                    </div>
                                    <v-card-actions>
                                      <v-btn
                                        :disabled="
                                          user.email !== matter.creatorID
                                        "
                                        @click="removeFirm(index)"
                                        >remove</v-btn
                                      >
                                    </v-card-actions>

                                    <hr
                                      size="1px"
                                      color="#a07800"
                                      style="width: 75%"
                                      class="ml-auto mr-auto mt-1 mb-1"
                                    />
                                    <!-- </v-row> -->
                                  </v-card>
                                </div>
                              </v-card>
                            </div>
                          </v-expand-transition>

                          <v-expand-transition>
                            <div v-if="showCreator">
                              <v-card-text class="display-1">
                                CASE ACCESS
                                <v-btn
                                  @click="togglShowCreator"
                                  rounded
                                  outlined
                                  small
                                  v-if="showCreator"
                                  color="red"
                                  >hide</v-btn
                                >
                              </v-card-text>

                              <v-card-text
                                class="title white--text font-weight-light"
                                style="border-radius: 26px; "
                                >CREATED BY:</v-card-text
                              >
                              <v-card-text
                                class="title blue--text font-weight-heavy"
                                style="border-radius: 26px; "
                                >{{ this.matter.creatorID }}</v-card-text
                              >
                              <hr
                                size="1px"
                                color="#a07800"
                                style="width: 75%"
                                class="ml-auto mr-auto mt-1 mb-1"
                              />
                              <v-card-text class="title font-weight-light"
                                >SHARED WITH:</v-card-text
                              >
                              <v-expand-transition
                                v-for="(shared, index) in this.matter
                                  .sharedWith"
                                :key="index"
                              >
                                <v-card
                                  style="background-color: #101010; height:50px"
                                  class="ma-2"
                                  v-if="shared !== matter.creatorID"
                                >
                                  <v-card-text
                                    class="title blue--text font-weight-heavy"
                                  >
                                    {{ shared }}
                                    <v-btn
                                      small
                                      color="red"
                                      outlined
                                      rounded
                                      dark
                                      class="ma-auto"
                                      @click="removeFromSharedList(shared)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </v-card-text>
                                </v-card>
                              </v-expand-transition>
                              <hr
                                size="1px"
                                color="#a07800"
                                style="width: 75%"
                                class="ml-auto mr-auto mt-1 mb-1"
                              />

                              <v-card-text class="headline font-weight-light">
                                SHARE THIS CASE WITHIN FIRM:
                                <v-btn
                                  @click="toggleShowSharing"
                                  rounded
                                  outlined
                                  small
                                  v-if="showSharing"
                                  color="red"
                                  >hide</v-btn
                                >
                                <v-btn
                                  @click="toggleShowSharing"
                                  rounded
                                  outlined
                                  small
                                  v-if="!showSharing"
                                  color="green"
                                  >view</v-btn
                                >
                              </v-card-text>
                              <v-expand-transition>
                                <div v-if="showSharing">
                                  <v-expand-transition
                                    v-for="(staff, index) in filteredUserList"
                                    :key="index"
                                  >
                                    <v-card
                                      style="background-color: black; border-radius: 26px; border: 1px solid #18CAE6; height:50px"
                                      class="ma-2"
                                      v-if="staff !== matter.creatorID"
                                    >
                                      <v-row>
                                        <v-flex>
                                          <v-card-text class="title">{{
                                            staff
                                          }}</v-card-text>
                                        </v-flex>
                                        <v-spacer></v-spacer>

                                        <v-flex>
                                          <v-card-text>
                                            <v-btn
                                              small
                                              color="blue"
                                              outlined
                                              rounded
                                              dark
                                              class="ma-auto"
                                              @click="addToSharedList(staff)"
                                              >share</v-btn
                                            >
                                          </v-card-text>
                                        </v-flex>
                                        <!-- </v-card-actions> -->
                                      </v-row>
                                    </v-card>
                                  </v-expand-transition>
                                </div>
                              </v-expand-transition>
                              <v-card-text
                                class="headline font-weight-light"
                                v-if="user.email == matter.creatorID"
                              >
                                SHARE THIS CASE WITH ANOTHER FIRM:
                                <v-btn
                                  @click="toggleShowOutsideSharing"
                                  rounded
                                  outlined
                                  small
                                  v-if="showOutsideSharing"
                                  color="red"
                                  >hide</v-btn
                                >
                                <v-btn
                                  @click="toggleShowOutsideSharing"
                                  rounded
                                  outlined
                                  small
                                  v-if="!showOutsideSharing"
                                  color="green"
                                  >view</v-btn
                                >
                              </v-card-text>
                              <v-expand-transition>
                                <div v-if="showOutsideSharing">
                                  <v-expand-transition>
                                    <v-card
                                      style="background-color: black; border-radius: 26px; border: 1px solid #18CAE6;"
                                      class="ma-2"
                                    >
                                      <!-- <v-card-text
                                        v-model="outsideUser"
                                      >Enter an email address to share:</v-card-text>-->
                                      <!-- <v-row> -->
                                      <!-- <v-flex> -->
                                      <!-- <v-card-text class="title">{{ staff }}</v-card-text> -->

                                      <!-- </v-flex> -->
                                      <!-- <v-spacer></v-spacer> -->

                                      <!-- <v-flex> -->
                                      <v-card-actions>
                                        <v-text-field
                                          color="#a07800"
                                          :rules="[rules.email]"
                                          type="email"
                                          label="EXTERNAL USER EMAIL"
                                          v-model="outsideUser"
                                          validate-on-blur
                                        ></v-text-field>

                                        <v-btn
                                          small
                                          color="blue"
                                          outlined
                                          rounded
                                          dark
                                          class="ma-auto"
                                          @click="shareWithOutsideUser"
                                          >share</v-btn
                                        >
                                      </v-card-actions>
                                      <!-- </v-flex> -->
                                      <!-- </v-card-actions> -->
                                      <!-- </v-row> -->
                                    </v-card>
                                  </v-expand-transition>
                                </div>
                              </v-expand-transition>
                            </div>
                          </v-expand-transition>

                          <v-expand-transition>
                            <div v-if="showInitialDocs">
                              <v-card-text class="display-1">
                                INITIAL DOCUMENTS
                                <v-btn
                                  rounded
                                  outlined
                                  small
                                  color="red"
                                  @click="toggleShowInitialDocs"
                                  v-if="showInitialDocs"
                                  >HIDE</v-btn
                                >
                              </v-card-text>
                              <template>
                                <div>
                                  <app-view-initial-docs
                                    :matter="matter"
                                    :user="user"
                                  ></app-view-initial-docs>
                                </div>
                              </template>
                              <!-- ADD INITIAL DOCUMENTS DIALOG -->
                              <template>
                                <div>
                                  <app-add-initial-docs-dialog
                                    :matter="matter"
                                  ></app-add-initial-docs-dialog>
                                </div>
                              </template>
                            </div>
                          </v-expand-transition>
                        </v-card>
                      </v-flex>
                    </v-expand-x-transition>
                    <!-- =================CASE INFO=================== -->
                    <v-expand-x-transition>
                      <v-flex
                        class="ma-auto"
                        xs12
                        sm12
                        md6
                        lg6
                        v-if="showServiceList"
                      >
                        <v-card
                          style="border: 1px solid black; overflow:auto;"
                          class="ma-2"
                          color="#E8E8E8"
                          max-height="50vh"
                          min-height="50vh"
                        >
                          <v-expand-transition>
                            <div v-if="showServiceList">
                              <v-card-text>
                                <v-btn
                                  rounded
                                  outlined
                                  small
                                  color="red"
                                  @click="toggleShowServiceList"
                                  v-if="showServiceList"
                                  >HIDE</v-btn
                                >

                                <div>
                                  <v-btn
                                    v-if="!addingServiceListItem"
                                    @click="onAddingItem"
                                    >ADD ITEM</v-btn
                                  >
                                </div>
                                <div v-if="matter.serviceList">
                                  <div
                                    v-for="(item, index) in matter.serviceList"
                                    :key="index"
                                  >
                                    <v-card
                                      style="background-color: black; border-radius: 26px; border: 1px solid #18CAE6; max-width: 650px;"
                                      class="ma-auto mb-2 white--text font-weight-light"
                                    >
                                      <div class="ma-3">
                                        <v-layout row class="ma-3">
                                          <v-flex
                                            style="border-right: 1px solid #18CAE6"
                                          >
                                            <div class="text-left">
                                              {{ index + 1 }}.
                                            </div>
                                            <div
                                              v-for="name in item.names"
                                              :key="name.value"
                                              class="text-left ml-3"
                                            >
                                              {{ name }}
                                            </div>
                                            <div class="text-left ml-3">
                                              {{ item.businessName }}
                                            </div>
                                            <div class="text-left ml-3">
                                              {{ item.address }}
                                            </div>
                                            <div class="text-left ml-3">
                                              {{ item.phone }}
                                            </div>
                                            <div class="text-left ml-3">
                                              {{ item.fax }}
                                            </div>
                                            <div
                                              v-for="email in item.emails"
                                              :key="email.value"
                                              class="text-left ml-3"
                                            >
                                              {{ email }}
                                            </div>
                                            <v-card-actions>
                                              <v-btn
                                                small
                                                outlined
                                                color="red"
                                                @click="removeServiceItem(item)"
                                                rounded
                                                >remove</v-btn
                                              >
                                              <v-btn
                                                small
                                                outlined
                                                color="red"
                                                @click="
                                                  editServiceListItem(
                                                    item,
                                                    index
                                                  )
                                                "
                                                rounded
                                                >edit</v-btn
                                              >
                                            </v-card-actions>
                                          </v-flex>

                                          <v-flex>{{ item.label }}</v-flex>
                                        </v-layout>
                                      </div>
                                    </v-card>
                                  </div>

                                  <!-- <div>
                                    <v-btn
                                      v-if="!addingServiceListItem"
                                      @click="onAddingItem"
                                    >ADD ITEM</v-btn>
                                  </div>-->
                                </div>
                                <div v-if="!matter.serviceList">
                                  YOU DO NOT HAVE A SERVICE LIST -- CREATE ONE
                                  HERE
                                </div>
                                <div>
                                  <!-- <v-btn
                                    v-if="!addingServiceListItem"
                                    @click="onAddingItem"
                                  >ADD ITEM</v-btn>-->
                                  <div v-if="addingServiceListItem">
                                    <v-dialog v-model="dialog" max-width="550">
                                      <v-card
                                        class="ma-auto"
                                        flat
                                        outlined
                                        style="background-color: black; border-radius: 26px; border: 3px solid #a07800; max-width: 550px;"
                                      >
                                        <v-card-title>
                                          <span class="headline"
                                            >ADD SERVICE RECIPIENT</span
                                          >
                                        </v-card-title>
                                        <v-form
                                          @submit.prevent="onAddServiceListItem"
                                        >
                                          <div>
                                            <div
                                              v-for="(name,
                                              i) in serviceListItemNames"
                                              :key="i"
                                            >
                                              <v-layout row class="ma-auto">
                                                <!-- <v-spacer></v-spacer> -->
                                                <v-flex class="ma-2">{{
                                                  name
                                                }}</v-flex>
                                                <v-flex
                                                  style="width: 20%"
                                                  class="ma-2"
                                                >
                                                  <v-btn
                                                    small
                                                    color="red"
                                                    @click="removeName(i)"
                                                    outlined
                                                    rounded
                                                    >remove</v-btn
                                                  >
                                                </v-flex>
                                                <v-spacer></v-spacer>
                                              </v-layout>
                                            </div>
                                          </div>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              required
                                              class="ma-2"
                                              outlined
                                              label="NAMES OF RECIPIENTS"
                                              hint="*(YOU MAY INPUT MULTIPLE NAMES FOR ONE RECIPIENT)"
                                              v-model="tempName"
                                              autofocus
                                              clearable
                                              color="#a07800"
                                              v-if="addingName"
                                            ></v-text-field>
                                          </v-expand-transition>

                                          <v-layout row class="ma-auto">
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              small
                                              rounded
                                              outlined
                                              v-if="addingServiceListItem"
                                              @click="addName"
                                              color="green"
                                            >
                                              ADD
                                              <span
                                                v-if="
                                                  serviceListItemNames.length &&
                                                    !this.addingName
                                                "
                                                class="ml-1 mr-1"
                                                >ANOTHER</span
                                              >
                                              NAME
                                            </v-btn>
                                          </v-layout>

                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="BUSINESS NAME OF RECIPIENTS"
                                              v-model="
                                                serviceListItemBusinessName
                                              "
                                              v-if="serviceListItemNames.length"
                                            ></v-text-field>
                                          </v-expand-transition>

                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="STREET ADDRESS"
                                              v-model="
                                                serviceListItemAddressLine
                                              "
                                              v-if="serviceListItemNames.length"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="CITY, STATE & ZIP"
                                              v-model="
                                                serviceListItemCityStateZip
                                              "
                                              v-if="serviceListItemAddressLine"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="PHONE OF RECIPENT"
                                              v-model="serviceListItemPhone"
                                              v-mask="mask"
                                              v-if="serviceListItemCityStateZip"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="FAX OF RECIPENT"
                                              v-model="serviceListItemFax"
                                              v-mask="mask"
                                              v-if="serviceListItemCityStateZip"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <div
                                            v-for="(email,
                                            i) in serviceListItemEmails"
                                            :key="email.value"
                                          >
                                            <v-layout row class="ma-auto">
                                              <!-- <v-spacer></v-spacer> -->
                                              <v-flex class="ma-2">{{
                                                email
                                              }}</v-flex>
                                              <v-flex
                                                style="width: 20%"
                                                class="ma-2"
                                              >
                                                <v-btn
                                                  small
                                                  color="red"
                                                  @click="removeEmail(i)"
                                                  outlined
                                                  rounded
                                                  >remove</v-btn
                                                >
                                              </v-flex>
                                              <v-spacer></v-spacer>
                                            </v-layout>
                                          </div>
                                          <!-- <div
                                          v-for="email in serviceListItemEmails"
                                          :key="email.value"
                                          >{{email}}</div>-->
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-4"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              validate-on-blur
                                              :rules="[rules.email]"
                                              label="EMAILS OF RECIPIENTS"
                                              v-model="tempEmail"
                                              v-if="serviceListItemCityStateZip"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-layout row class="ma-auto">
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              small
                                              rounded
                                              outlined
                                              v-if="serviceListItemCityStateZip"
                                              @click="addEmail"
                                              color="green"
                                              >ADD EMAIL</v-btn
                                            >
                                          </v-layout>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="DESCRIBE THIS RECIPIENT"
                                              v-model="serviceListItemLabel"
                                              v-if="serviceListItemCityStateZip"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-expand-transition>
                                            <v-select
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              :items="serviceListItemTypes"
                                              label="SELECT A TYPE OF SERVICE FOR THIS RECIPIENT"
                                              v-model="serviceListItemType"
                                              v-if="serviceListItemLabel"
                                            ></v-select>
                                          </v-expand-transition>
                                          <v-btn type="submit">submit</v-btn>
                                        </v-form>
                                      </v-card>
                                    </v-dialog>
                                  </div>
                                  <!-- ===========editing service list item dialog================= -->
                                  <div v-if="editingServiceListItem">
                                    <v-dialog
                                      v-model="editDialog"
                                      max-width="550"
                                    >
                                      <v-card
                                        class="ma-auto"
                                        flat
                                        outlined
                                        style="background-color: black; border-radius: 26px; border: 3px solid #a07800; max-width: 550px;"
                                      >
                                        <v-card-title>
                                          <span class="headline"
                                            >EDIT SERVICE RECIPIENT</span
                                          >
                                        </v-card-title>
                                        <v-form
                                          @submit.prevent="
                                            onEditServiceListItem
                                          "
                                        >
                                          <div>
                                            <div
                                              v-for="(name,
                                              i) in serviceListItemToBeEdited.names"
                                              :key="i"
                                            >
                                              <v-layout row class="ma-auto">
                                                <v-flex class="ma-2">{{
                                                  name
                                                }}</v-flex>
                                                <v-flex
                                                  style="width: 20%"
                                                  class="ma-2"
                                                >
                                                  <v-btn
                                                    small
                                                    color="red"
                                                    @click="
                                                      removeNameFormServiceListItem(
                                                        i
                                                      )
                                                    "
                                                    outlined
                                                    rounded
                                                    >remove</v-btn
                                                  >
                                                </v-flex>
                                                <v-spacer></v-spacer>
                                              </v-layout>
                                            </div>
                                          </div>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              required
                                              class="ma-2"
                                              outlined
                                              label="NAMES OF RECIPIENTS"
                                              hint="*(YOU MAY INPUT MULTIPLE NAMES FOR ONE RECIPIENT)"
                                              v-model="tempName"
                                              autofocus
                                              clearable
                                              color="#a07800"
                                              v-if="addingName"
                                            ></v-text-field>
                                          </v-expand-transition>

                                          <v-layout row class="ma-auto">
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              small
                                              rounded
                                              outlined
                                              @click="
                                                addNameToEditingServiceListItem
                                              "
                                              color="green"
                                              >ADD NAME</v-btn
                                            >
                                          </v-layout>

                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="BUSINESS NAME OF RECIPIENTS"
                                              v-model="
                                                serviceListItemToBeEdited.businessName
                                              "
                                            ></v-text-field>
                                          </v-expand-transition>

                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="STREET ADDRESS"
                                              v-model="
                                                serviceListItemToBeEdited.addressLine
                                              "
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="CITY, STATE & ZIP"
                                              v-model="
                                                serviceListItemToBeEdited.cityStateZip
                                              "
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="PHONE OF RECIPENT"
                                              v-model="
                                                serviceListItemToBeEdited.phone
                                              "
                                              v-mask="mask"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="FAX OF RECIPENT"
                                              v-model="
                                                serviceListItemToBeEdited.fax
                                              "
                                              v-mask="mask"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <div
                                            v-for="(email,
                                            i) in serviceListItemToBeEdited.emails"
                                            :key="email.value"
                                          >
                                            <v-layout row class="ma-auto">
                                              <v-flex class="ma-2">{{
                                                email
                                              }}</v-flex>
                                              <v-flex
                                                style="width: 20%"
                                                class="ma-2"
                                              >
                                                <v-btn
                                                  small
                                                  color="red"
                                                  @click="removeEditingEmail(i)"
                                                  outlined
                                                  rounded
                                                  >remove</v-btn
                                                >
                                              </v-flex>
                                              <v-spacer></v-spacer>
                                            </v-layout>
                                          </div>

                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-4"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              validate-on-blur
                                              :rules="[rules.email]"
                                              label="EMAILS OF RECIPIENTS"
                                              v-model="tempEmail"
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-layout row class="ma-auto">
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              small
                                              rounded
                                              outlined
                                              @click="addEditingEmail"
                                              color="green"
                                              >ADD EMAIL</v-btn
                                            >
                                          </v-layout>
                                          <v-expand-transition>
                                            <v-text-field
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              label="DESCRIBE THIS RECIPIENT"
                                              v-model="
                                                serviceListItemToBeEdited.label
                                              "
                                            ></v-text-field>
                                          </v-expand-transition>
                                          <v-expand-transition>
                                            <v-select
                                              dense
                                              class="ma-2"
                                              outlined
                                              clearable
                                              color="#a07800"
                                              :items="serviceListItemTypes"
                                              label="SELECT A TYPE OF SERVICE FOR THIS RECIPIENT"
                                              v-model="
                                                serviceListItemToBeEdited.type
                                              "
                                            ></v-select>
                                          </v-expand-transition>
                                          <v-btn type="submit">submit</v-btn>
                                        </v-form>
                                      </v-card>
                                    </v-dialog>
                                  </div>
                                </div>
                              </v-card-text>
                            </div>
                          </v-expand-transition>
                        </v-card>
                      </v-flex>
                    </v-expand-x-transition>

                    <v-expand-x-transition>
                      <v-flex
                        class="ma-auto"
                        xs12
                        sm12
                        md6
                        lg6
                        v-if="showCaseInfo"
                      >
                        <!-- <v-card
                          style="border: 2px solid black; width: auto;  overflow:auto;"
                          class="ma-2"
                          color="#E8E8E8"
                          max-height="50vh"
                          min-height="50vh"
                        > -->
                        <v-expand-transition>
                          <div v-if="showCaseInfo">
                            <v-card
                              style="border: 2px solid black; width: auto;  overflow:auto;"
                              class="ma-2"
                              color="#E8E8E8"
                              max-height="50vh"
                              min-height="50vh"
                            >
                              <v-row>
                                <v-col></v-col>
                                <v-col
                                  ><v-card-text class="title"
                                    >CASE INFO</v-card-text
                                  ></v-col
                                >
                                <v-col
                                  ><v-btn
                                    rounded
                                    small
                                    text
                                    class="red--text"
                                    @click="showCaseInfo = !showCaseInfo"
                                    v-if="showCaseInfo"
                                    >HIDE</v-btn
                                  ></v-col
                                >
                              </v-row>
                              <v-card class="ma-auto" max-width="800px">
                                <v-simple-table
                                  class="text-left ml-3 body-2"
                                  dense
                                >
                                  <tbody>
                                    <tr>
                                      <td class="body">DATE OF LOSS</td>
                                      <td
                                        class="body"
                                        style="border-left: 1px solid #a07800"
                                      >
                                        {{ matter ? matter.dateOfLoss : "**" }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="body">DATE FILED</td>
                                      <td
                                        class="body"
                                        v-if="matter && !matter.dateOfComplaint"
                                        style="border-left: 1px solid #a07800"
                                      >
                                        <v-btn
                                          rounded
                                          outlined
                                          color="green"
                                          @click="editDateOfComplaint"
                                          >INPUT DATE OF COMPLAINT</v-btn
                                        >
                                      </td>
                                      <td
                                        class="body"
                                        v-else
                                        style="border-left: 1px solid #a07800"
                                      >
                                        {{
                                          matter ? matter.dateOfComplaint : "**"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="body">
                                        COMPLAINT DEADLINE
                                      </td>
                                      <td
                                        class="body"
                                        style="border-left: 1px solid #a07800"
                                      >
                                        {{
                                          matter
                                            ? matter.complaintDeadline
                                            : "**"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="body">
                                        STATUTE OF LIMITATIONS
                                      </td>
                                      <td
                                        class="body"
                                        style="border-left: 1px solid #a07800"
                                      >
                                        {{
                                          matter
                                            ? matter.statuteOfLimitations
                                            : "**"
                                        }}
                                        years
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="body">STATUS</td>
                                      <td
                                        class="body"
                                        style="border-left: 1px solid #a07800"
                                      >
                                        {{
                                          matter
                                            ? matter.status.toUpperCase()
                                            : "**"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="body">DATE CREATED</td>
                                      <td
                                        class="body"
                                        style="border-left: 1px solid #a07800"
                                      >
                                        {{ matter ? matter.dateCreated : "**" }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="body">ID</td>
                                      <td
                                        class="body"
                                        style="border-left: 1px solid #a07800"
                                      >
                                        {{ matter ? matter.matterSlug : "**" }}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td class="body">CREATOR</td>
                                      <td
                                        class="body"
                                        style="border-left: 1px solid #a07800"
                                      >
                                        {{ matter ? matter.creatorID : "**" }}
                                      </td>
                                    </tr>
                                    <tr></tr></tbody
                                ></v-simple-table>
                              </v-card>
                            </v-card>
                          </div>
                        </v-expand-transition>
                        <!-- </v-card> -->
                      </v-flex>
                    </v-expand-x-transition>
                    <v-expand-x-transition>
                      <v-flex
                        class="ma-auto"
                        v-if="showNotes"
                        xs12
                        sm12
                        md6
                        lg6
                      >
                        <v-card
                          style="border: 1px solid black; overflow:auto;"
                          class="ma-2"
                          color="#E8E8E8"
                          max-height="50vh"
                          min-height="50vh"
                        >
                          <v-expand-transition>
                            <div v-if="showNotes">
                              <v-row class="mt-1">
                                <v-col>
                                  <template>
                                    <div>
                                      <app-add-matter-notes
                                        :matter="matter"
                                        :user="user"
                                      ></app-add-matter-notes>
                                    </div>
                                  </template>
                                </v-col>
                                <v-col
                                  ><v-card-text class="title"
                                    >NOTES</v-card-text
                                  ></v-col
                                >
                                <v-col
                                  ><v-btn
                                    text
                                    small
                                    color="red"
                                    @click="toggleShowNotes"
                                    v-if="showNotes"
                                    >HIDE</v-btn
                                  ></v-col
                                >
                              </v-row>
                              <v-card-text>
                                <template>
                                  <div>
                                    <app-view-matter-notes
                                      :matter="matter"
                                      :user="user"
                                    ></app-view-matter-notes>
                                  </div>
                                </template>
                                <!-- <template>
                                  <div>
                                    <app-add-matter-notes :matter="matter" :user="user"></app-add-matter-notes>
                                  </div>
                                </template>-->
                              </v-card-text>
                            </div>
                          </v-expand-transition></v-card
                        ></v-flex
                      ></v-expand-x-transition
                    >
                    <v-expand-x-transition>
                      <v-flex
                        class="ma-auto"
                        v-if="showActivities"
                        xs12
                        sm12
                        md6
                        lg6
                      >
                        <v-card
                          style="border: 1px solid black; overflow:auto;"
                          class="ma-2"
                          color="#E8E8E8"
                          max-height="50vh"
                          min-height="50vh"
                        >
                          <v-expand-transition>
                            <div v-if="showActivities">
                              <v-row class="mt-1">
                                <v-col>
                                  <v-btn
                                    color="red"
                                    small
                                    text
                                    @click="deleteActivities"
                                    >DELETE ALL</v-btn
                                  ></v-col
                                >
                                <v-col>
                                  <v-card-text class="title"
                                    >ACTIVITIES</v-card-text
                                  ></v-col
                                >
                                <v-col>
                                  <v-btn
                                    text
                                    small
                                    color="red"
                                    @click="toggleShowActivities"
                                    v-if="showActivities"
                                    >HIDE</v-btn
                                  ></v-col
                                >
                              </v-row>

                              <v-card-text>
                                <!-- <v-btn
                                  rounded
                                  outlined
                                  small
                                  color="red"
                                  @click="toggleShowActivities"
                                  v-if="showActivities"
                                  >HIDE</v-btn
                                > -->
                                <template>
                                  <div>
                                    <app-view-matter-activities
                                      :matter="matter"
                                      :user="user"
                                    ></app-view-matter-activities>
                                  </div>
                                </template>
                                <!-- <template>
                                  <div>
                                    <app-add-matter-notes :matter="matter" :user="user"></app-add-matter-notes>
                                  </div>
                                </template>-->
                              </v-card-text>
                            </div>
                          </v-expand-transition>
                        </v-card>
                      </v-flex>
                    </v-expand-x-transition>
                  </v-layout>
                </v-container>

                <!-- <hr
                  size="1px"
                  color="#18CAE6"
                  style="width: 75%"
                  class="ml-auto mr-auto mt-1 mb-1"
                /> -->

                <!-- ACTION CARD  -->
                <v-container class="ma-auto s12">
                  <v-layout text-center row class="ma-auto">
                    <!-- <v-card-text>
                      <template>
                        <div>
                          <app-view-form-resps :matter="matter" :user="user"></app-view-form-resps>
                        </div>
                      </template>
                    </v-card-text>-->
                  </v-layout>
                </v-container>

                <hr
                  size="1px"
                  color="#18CAE6"
                  style="width: 75%"
                  class="ml-auto mr-auto mt-1 mb-1"
                />
              </v-card>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- </v-main> -->
    </v-container>
  </div>
</template>

<script>
/**
 *
 *
 * THIS COMPONENT LOADS EVERYTHING ABOUT THE MATTER
 * ITS THE COMPONENT YOU WILL SEE MOST OFTEN WHEN ON THE APP
 * THE COMPONENT TIES INTO ALMOST ALL OTHER COMPONENTS
 * THE COMPONENT IS LOADED AT THE ROUTER: /matters/:matterSlug
 * the matter is a computed value grabbed from Vuex Store dispatching a getter
 *
 *
 */
import firebase from "firebase";
import * as moment from "moment";

import { mask } from "vue-the-mask";

export default {
  props: ["id"],
  directives: {
    mask
  },
  data: () => ({
    drawer: true,
    rightDrawer: true,
    dialog: false,
    editDialog: false,
    serviceListItemNames: [],
    serviceListItemBusinessName: null,
    serviceListItemAddressLine: null,
    serviceListItemCityStateZip: null,
    serviceListItemPhone: null,
    serviceListItemFax: null,
    serviceListItemEmails: [],
    serviceListItemLabel: null,
    serviceListItemType: null,
    serviceListItemTypes: ["Electronic-Transfer", "Mail", "Overnight-Delivery"],
    serviceListItemToBeEdited: null,

    addingName: true,
    tempName: null,
    tempEmail: null,

    serviceList: [],

    showCreator: false,
    addingServiceListItem: false,
    editingServiceListItem: false,
    showCaseInfo: true,
    showSharing: false,
    showOutsideSharing: false,
    showAttorneys: false,
    showFirms: false,
    showInitialDocs: false,
    showPlaintiffs: true,
    showDefendants: false,
    showFormResponses: false,
    showServiceList: false,
    showNotes: true,
    showActivities: false,
    selectedParty: null,
    hidePlaintiffCards: false,
    plaintiffView: false,
    viewingPlaintiff: null,
    fullName: null,
    phone: null,
    email: null,
    attorney: null,
    addingPlaintiff: false,
    resps: [],
    shareList: [],
    reversedActivities: [],
    outsideUser: null,
    // filteredUserList: [],
    mask: "(###) ###-####",
    dateMask: "##/##/####",
    dateOfComplaint: null,
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    },

    editDateOfComplaintDialog: false,
    editStatuteOfLimitationsDialog: false,
    statuteOfLimitations: null,
    statuteTerms: [1, 2, 3, 4],
    tempComplaintDeadline: null,
    letterhead: null,
    canvasDialog: false
  }),
  computed: {
    matter() {
      return this.$store.getters.getMatter(this.$route.params.id);
    },
    isLoading() {
      return this.$store.getters.loading;
    },
    // plaintiffs() {
    //   return this.$store.getters.loadedPlaintiffs;
    // },
    user() {
      return this.$store.getters.user;
    },
    firm() {
      return this.$store.getters.firm;
    },
    filteredUserList() {
      let list = [];
      if (this.firm !== null && this.firm !== undefined) {
        this.firm.userlist.forEach(user => {
          if (this.matter.sharedWith.includes(user)) {
            return;
            //   this.shareList.push(user);
            // } else {
          } else {
            list.push(user);
          }
        });
      }
      return list;
    },
    middleView() {
      if (
        // this.showCaseInfo ||
        this.showPlaintiffs ||
        this.showDefendants ||
        this.showAttorneys ||
        this.showInitialDocs ||
        this.showCreator ||
        this.showInitialDocs ||
        this.showFirms
      ) {
        return true;
      } else {
        return false;
      }
    },
    rightView() {
      if (this.caseInfo || this.showFormResponses || this.showServiceList) {
        return true;
      } else {
        return false;
      }
    },
    complaintDeadline() {
      if (
        this.statuteOfLimitations !== null &&
        this.statuteOfLimitations !== undefined
      ) {
        if (
          this.matter.dateOfLoss !== null &&
          this.matter.dateOfLoss !== undefined
        ) {
          if (this.statuteOfLimitations === 1) {
            let date = moment(`${this.matter.dateOfLoss}`)
              .add(1, "year")
              .format("LL");
            // this.tempComplaintDeadline = date;
            return date;
          } else if (this.statuteOfLimitations === 2) {
            let date = moment(`${this.matter.dateOfLoss}`)
              .add(2, "year")
              .format("LL");
            // this.tempComplaintDeadline = date;
            return date;
          } else if (this.statuteOfLimitations === 3) {
            let date = moment(`${this.matter.dateOfLoss}`)
              .add(3, "year")
              .format("LL");
            // this.tempComplaintDeadline = date;
            return date;
          } else if (this.statuteOfLimitations === 4) {
            let date = moment(`${this.matter.dateOfLoss}`)
              .add(4, "year")
              .format("LL");
            // this.tempComplaintDeadline = date;
            return date;
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    dayOfWeek() {
      if (this.matter.complaintDeadline) {
        let day = moment(`${this.matter.complaintDeadline}`).format("dddd");
        let dateString;
        if (day === "Saturday") {
          dateString = `Your statute of limitations falls on a Saturday, to be safe, file your complaint by: ${moment(
            this.matter.complaintDeadline
          )
            .subtract(1, "days")
            .format("dddd MMMM Do YYYY")}`;
          return dateString;
        } else if (day === "Sunday") {
          dateString = `Your statute of limitations falls on a Sunday, to be safe, file your complaint by: ${moment(
            this.matter.complaintDeadline
          )
            .subtract(2, "days")
            .format("dddd MMMM Do YYYY")}`;
          return dateString;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  },
  watch: {
    dialog(val) {
      if (val == false) {
        this.addingServiceListItem = false;
      }
    },
    editDialog(val) {
      if (val == false) {
        this.editingServiceListItem = false;
      }
    },
    editDateOfComplaintDialog(val) {
      if (val == false) {
        this.dateOfComplaint = null;
      }
    },
    editStatuteOfLimitationsDialog(val) {
      if (val == false) {
        this.statuteOfLimitations = null;
      }
    },
    showPlaintiffs(val) {
      if (val === true) {
        this.showDefendants = false;
        // this.showCaseInfo = false;
        this.showCreator = false;
        this.showAttorneys = false;
        this.showFirms = false;
      }
    },
    showDefendants(val) {
      if (val === true) {
        this.showPlaintiffs = false;
        // this.showCaseInfo = false;
        this.showCreator = false;
        this.showAttorneys = false;
        this.showFirms = false;
      }
    },
    showNotes(val) {
      if (val === true) {
        this.showServiceList = false;
      }
    },
    // // showCaseInfo(val) {
    // //   if (val === true) {
    // //     // this.showPlaintiffs = false;
    // //     // this.showDefendants = false;
    // //     // this.showCreator = false;
    // //     // this.showAttorneys = false;
    // //     // this.showFirms = false;
    // //   }
    // },
    showCreator(val) {
      if (val === true) {
        this.showPlaintiffs = false;
        this.showDefendants = false;
        this.showCaseInfo = false;
        this.showAttorneys = false;
        this.showFirms = false;
      }
    },
    showAttorneys(val) {
      if (val === true) {
        this.showPlaintiffs = false;
        this.showDefendants = false;
        this.showCaseInfo = false;
        this.showCreator = false;
        // this.showFirms = false;
      }
    },
    // showFirms(val) {
    //   if (val === true) {
    //     this.showPlaintiffs = false;
    //     this.showDefendants = false;
    //     this.showCaseInfo = false;
    //     this.showCreator = false;
    //     this.attorneys = false;
    //   }
    // },
    user(val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("getFirm", this.user.firmSlug);
      }
    },
    // shareList(val) {
    //   console.log("shareList from watch", val);
    //   //set the sharedWith list to include the values in the share list
    // }
    // initialDocs(value) {
    //   // this.$store.dispatch("getFirm", this.user.firmSlug);
    //   console.log("valua from initialDocs watcher in matter", value);
    // },
    // firm(val) {
    //   val.userlist.forEach(user => {
    //     if (!this.matter.sharedWith.includes(user)) {
    //       //   this.shareList.push(user);
    //       // } else {
    //       // this.filteredUserList.push(user);
    //     }
    //   });
    //   // return list;
    // }
    matter(value) {
      if (value.activities) {
        this.reversedActivities = value.activities.reverse();
        console.log(
          "matter has activities from watch at matter",
          value.activities
        );
      }
      if (value.caseName) {
        window.document.title = `${this.matter.caseName.toUpperCase()}`;
      }
    },
    complaintDeadline(val) {
      if (
        this.matter.dateOfLoss !== null &&
        this.matter.dateOfLoss !== undefined
      ) {
        this.tempComplaintDeadline = val;
      }
    }
  },

  methods: {
    deleteActivities() {
      alert(
        "are you sure you want to permanently delete ALL the activities that have been logged in this matter? "
      );
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          activities: []
        })
        .then(() => {
          console.log("successfully deleted activities");
        });
    },
    removeFirm(index) {
      let firms = this.matter.firms;
      firms.splice(index, 1);
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          firms: firms
        });
    },
    editDateOfComplaint() {
      this.editDateOfComplaintDialog = true;
    },
    editStatuteOfLimitations() {
      this.editStatuteOfLimitationsDialog = true;
    },
    onEditStatuteOfLimitations() {
      console.log("something here from oneditStatute...");
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          complaintDeadline: this.tempComplaintDeadline
        })

        .then(() => {
          // this.tempComplaintDeadline = null;
          this.statuteOfLimitations = null;
          this.editStatuteOfLimitationsDialog = false;
        })
        .catch(e => {
          console.error(e);
        });
    },
    onEditDateOfComplaint() {
      let dateOfComplaint = moment(`${this.dateOfComplaint}`).format(
        "MMMM Do YYYY"
      );
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          dateOfComplaint
        })

        .then(() => {
          this.dateOfComplaint = null;
          this.editDateOfComplaintDialog = false;
        })
        .catch(e => {
          console.error(e);
        });
    },
    removeName(i) {
      this.serviceListItemNames.splice(i, 1);
    },
    //when editing service list item
    removeNameFormServiceListItem(i) {
      this.serviceListItemToBeEdited.names.splice(i, 1);
    },
    removeBusinessName() {
      this.serviceListItemBusinessName = null;
    },
    removeEmail(i) {
      this.serviceListItemEmails.splice(i, 1);
    },
    removeEditingEmail(i) {
      this.serviceListItemToBeEdited.emails.splice(i, 1);
    },
    onAddingItem() {
      this.dialog = true;
      this.addingServiceListItem = true;
      this.addingName = true;
    },
    editServiceListItem(item, index) {
      console.log("service lidt item", item);
      console.log("index", index);

      this.editDialog = true;
      this.editingServiceListItem = true;
      //??
      this.addingName = true;
      this.serviceListItemToBeEdited = item;
      this.editingIndex = index;
    },
    removeServiceItem(item) {
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          serviceList: firebase.firestore.FieldValue.arrayRemove(item)
        });
    },
    onAddServiceListItem() {
      let serviceListItem = {
        names: this.serviceListItemNames,
        businessName: this.serviceListItemBusinessName,
        addressLine: this.serviceListItemAddressLine,
        cityStateZip: this.serviceListItemCityStateZip,
        phone: this.serviceListItemPhone,
        fax: this.serviceListItemFax,
        emails: this.serviceListItemEmails,
        label: this.serviceListItemLabel,
        type: this.serviceListItemType
      };
      // this.serviceList.push(serviceListItem);
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          serviceList: firebase.firestore.FieldValue.arrayUnion(serviceListItem)
        })
        .then(() => {
          this.serviceListItemNames = [];
          this.serviceListItemBusinessName = null;
          this.serviceListItemCityStateZip = null;
          this.serviceListItemAddressLine = null;
          this.serviceListItemPhone = null;
          this.serviceListItemFax = null;
          this.serviceListItemEmails = [];
          this.serviceListItemLabel = null;
          this.serviceListItemType = null;

          this.addingServiceListItem = false;
          this.dialog = false;
        })
        .catch(e => {
          console.error(e);
        });
    },
    onEditServiceListItem() {
      let serviceList = this.matter.serviceList;
      serviceList.splice(this.editingIndex, 1, this.serviceListItemToBeEdited);
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          serviceList
        })

        .then(() => {
          this.serviceListItemToBeEdited = null;
          this.editDialog = false;
        })
        .catch(e => {
          console.error(e);
        });
    },
    addEmail() {
      this.serviceListItemEmails.push(this.tempEmail);
      this.tempEmail = null;
    },
    addEditingEmail() {
      this.serviceListItemToBeEdited.emails.push(this.tempEmail);
      this.tempEmail = null;
    },
    addName() {
      if (this.addingName) {
        this.serviceListItemNames.push(this.tempName);
        this.tempName = null;
        this.addingName = false;
      } else {
        this.addingName = true;
      }
    },
    addNameToEditingServiceListItem() {
      if (this.addingName) {
        this.serviceListItemToBeEdited.names.push(this.tempName);
        this.tempName = null;
        this.addingName = false;
      } else {
        this.addingName = true;
      }
    },
    toggleShowServiceList() {
      this.showServiceList = !this.showServiceList;
    },
    toggleShowNotes() {
      this.showNotes = !this.showNotes;
    },
    toggleShowActivities() {
      this.showActivities = !this.showActivities;
    },
    toggleShowFormResponses() {
      this.showFormResponses = !this.showFormResponses;
    },
    toggleShowPlaintiffs() {
      this.showPlaintiffs = !this.showPlaintiffs;
    },
    toggleShowDefendants() {
      this.showDefendants = !this.showDefendants;
    },
    toggleShowInitialDocs() {
      this.showInitialDocs = !this.showInitialDocs;
    },
    togglShowCreator() {
      this.showCreator = !this.showCreator;
    },
    toggleShowCaseInfo() {
      this.showCaseInfo = !this.showCaseInfo;
    },
    toggleShowSharing() {
      this.showSharing = !this.showSharing;
    },
    toggleShowOutsideSharing() {
      this.showOutsideSharing = !this.showOutsideSharing;
    },
    toggleShowAttorneys() {
      this.showAttorneys = !this.showAttorneys;
    },
    toggleShowFirms() {
      this.showFirms = !this.showFirms;
    },

    //SEE sendSharedWithEmailToNewUser
    //this is supposed to check if the email that the user wants to share this matter with
    //is already a user is so, it should just ass that user to the sharedWith list in the matter doc in db
    //if not, an email should be sent tot he user

    //This function should also send an email if the user is already a user
    //it should just have the route to the matter in the email and notify each person that has access
    //that a new person now has access that is not within the firm...
    shareWithOutsideUser() {
      let user = this.outsideUser.toLowerCase();

      if (this.matter.sharedWith.includes(user)) {
        alert(`${this.outsideUser} is already on the shared list`);
        return;
        //   this.shareList.push(user);
        // } else {
      } else {
        firebase
          .firestore()
          .collection("firms")
          .doc(this.user.firmSlug)
          .collection("matters")
          .doc(this.matter.matterSlug)
          .update({
            sharedWith: firebase.firestore.FieldValue.arrayUnion(user)
          })
          .then(() => {
            firebase
              .firestore()
              .collection("matters")
              .doc(this.matter.matterSlug)
              .update({
                sharedWith: firebase.firestore.FieldValue.arrayUnion(user)
              })
              .catch(e => {
                console.error(e);
              });
          })
          .then(() => {
            firebase
              .firestore()
              .collection("users")
              // .where("email", "==", user.email)
              .where("email", "==", user)
              .get()
              .then(users => {
                console.log(users);
                // users.forEach(user => {
                // console.log(user.data());
                //DOES THIS WORK??
                if (user.exists) {
                  console.log("this user exists");
                  //save this matter to the user or add this user to the matter
                } else {
                  alert(
                    "this is not a user yet, I will now send this person an email to join"
                  );
                  const sendSharedWithEmailToNewUser = firebase
                    .functions()
                    .httpsCallable("sendSharedWithEmailToNewUser");
                  sendSharedWithEmailToNewUser({
                    link: `https://www.taplaw.com/signup`,
                    email: `${this.outsideUser}`,
                    matter: this.matter,
                    user: this.user
                  });
                }
                // });
              })
              .then(() => {
                this.outsideUser = null;
                this.showOutsideSharing = false;
              })
              .catch(e => {
                console.error(e);
              });
          })
          .catch(e => {
            console.error(e);
          });
      }
    },
    addToSharedList(staff) {
      console.log(staff);
      firebase
        .firestore()
        .collection("firms")
        .doc(this.user.firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          sharedWith: firebase.firestore.FieldValue.arrayUnion(staff)
        })
        .then(() => {
          firebase
            .firestore()
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              sharedWith: firebase.firestore.FieldValue.arrayUnion(staff)
            })
            .catch(e => {
              console.error(e);
            });
        })
        .catch(e => {
          console.error(e);
        });
    },
    removeFromSharedList(shared) {
      console.log(shared);
      firebase
        .firestore()
        .collection("firms")
        .doc(this.user.firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          sharedWith: firebase.firestore.FieldValue.arrayRemove(shared)
        })
        .then(() => {
          firebase
            .firestore()
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              sharedWith: firebase.firestore.FieldValue.arrayRemove(shared)
            })
            .catch(e => {
              console.error(e);
            });
        })
        .catch(e => {
          console.error(e);
        });
    },
    deleteAttorney(attorney) {
      firebase
        .firestore()
        // .collection("firms")
        // .doc(this.user.firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          attorneys: firebase.firestore.FieldValue.arrayRemove(attorney)
        });
    },
    logmatter() {
      console.log(this.matter);
    },
    viewPlaintiff(plaintiff) {
      this.plaintiffView = true;
      this.hidePlaintiffCards = true;
      this.viewingPlaintiff = plaintiff;
    },
    closeViewPlaintiff() {
      this.plaintiffView = false;
      this.hidePlaintiffCards = false;
      this.viewingPlaintiff = null;
    },
    // openDoc(doc) {
    //   window.open(doc.url, "_blank");
    // },
    addPlaintiff() {
      this.addingPlaintiff = true;
    },
    cancelAddPlaintiff() {
      this.addingPlaintiff = false;
    },
    onAddPlaintiff() {
      this.plaintiffView = false;
      this.hidePlaintiffCards = false;
      this.viewingPlaintiff = null;
      // console.log(this.matter.id);
      // if (this.fullName !== null && this.fullName !== undefined) {
      // 	const updatedMatter = {
      // 		id: `${this.matter.id}`,
      // 		plaintiff: {
      // 			name: this.fullName,
      // 			phone: this.phone,
      // 			email: this.email,
      // 			attorney: this.attorney
      // 		}
      // 	};
      // 	this.$store.dispatch("addPlaintiff", updatedMatter);
      // }
    },
    onDeletePlaintiff(plaintiff) {
      console.log(plaintiff);
      // const payload = {
      //   matterID: this.matter.id,
      //   plaintiffID: plaintiff.id,

      // };
      // console.log(plaintiff);
      // this.$store.dispatch("deletePlaintiff", payload);
    },
    onDeleteMatter() {
      // send the matter to store
      const { matter } = this;
      console.log("matter", matter);
      console.log("user", this.user);
      let payload = {
        matter,
        user: this.user
      };
      console.log("payload", payload);
      if (
        window.confirm(
          `are you sure you want to permanently delete this matter ${matter.caseName}`
        )
      ) {
        this.$store.dispatch("deleteMatter", payload);
        this.$router.push("/matters");
      }
    },
    // logPlaintiffs() {
    // 	console.log(this.plaintiffs);
    // }
    onFilePicked() {
      if (event.target.files) {
        this.canvasDialog = true;
        const fileList = Array.from(event.target.files);
        fileList.forEach(file => {
          console.log(file);
          this.letterhead = file;
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = function() {
            let image = new Image();
            image.src = reader.result;
            image.onload = () => {
              let canvas = document.getElementById("temp-canvas");
              canvas.width = image.width;
              canvas.height = image.height;
              let ctx = canvas.getContext("2d");
              ctx.drawImage(image, 0, 0);
            };
          };
        });
      }
    },
    saveLetterhead() {
      if (this.letterhead !== null && this.letterhead !== undefined) {
        this.canvasDialog = true;
        console.log("lettehead", this.letterhead);
        console.log("firm: ", this.firm);

        let letterHeadRef = firebase
          .storage()
          .ref(`/firms/${this.user.firmSlug}/letterhead.png`);
        letterHeadRef
          .put(this.letterhead)
          .then(() => {
            console.log("letterhead saved");
            letterHeadRef
              .getDownloadURL()
              .then(url => {
                let letterhead = {
                  url: url,
                  name: this.letterhead.name
                };
                firebase
                  .firestore()
                  .collection("matters")
                  .doc(this.matter.matterSlug)
                  .update({ letterhead: letterhead })
                  .then(() => {
                    (async () => {
                      let canvas = document.getElementById("temp-canvas");
                      const base64Canvas = await canvas.toDataURL("image/png");
                      firebase
                        .firestore()
                        .collection("matters")
                        .doc(this.matter.matterSlug)
                        .update({ letterheadData: base64Canvas });
                      await this.$refs.fileInput.clear;
                      this.canvasDialog = false;
                      canvas.src = "";
                    })();
                  })
                  .catch(e => {
                    console.error(e);
                  });
              })
              .catch(e => {
                console.error(e);
              });
          })
          .catch(e => {
            console.error(e);
          });
      }
    }
  },
  created() {
    console.log("hello from created at Matter, the matter is: ", this.matter);
    console.log("hello from created at Matter, the user is: ", this.user);
    console.log("hello from created at Matter, route is: ", this.$route);
    // if (this.matter && this.user) {
    // this.$store.dispatch("getFirm", this.user.firmSlug);
    // }
    console.log("hello from created at Matter, the firm is: ", this.firm);
    if (this.matter && this.matter.caseName) {
      window.document.title = `${this.matter.caseName.toUpperCase()}`;
    }

    //add a snapshot listener that will get a client's form responses and notify the user that it has been created
    //   /firms/first-firm/matters/5th-matter-20191101/clients/first-plaintiff-111-1111111

    //then the user can access the form responses and save them

    // =====EXPERIMENTAL=======
    // firebase
    //   .firestore()
    //   .collection("firms")
    //   .get()
    //   .then(snapshot => {
    //     snapshot.forEach(firm => {
    //       console.log("firm", firm.data());
    //       firm.userlist.forEach(user => {
    //         if (this.matter.sharedWith.includes(user)) {
    //           return;
    //           //   this.shareList.push(user);
    //           // } else {
    //         } else {
    //           this.outsideUserList.push(user);
    //         }
    //       });
    //     });
    //   });
  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 1px;
  background: transparent;
}
/* .stick {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
} */
</style>
